<!-- Structure aligned with AngularJS: dst-statements-filed-status.html -->
<div id="dst-statements-filed-status-inner" class="main-content">
  <h3 class="page-title">DST Statements Filed Status</h3>
  <br />

  <div class="d-flex filters-row filters-same-line">
    <b class="mt-2 ml-2 filter-label">Tax Year:</b>
    <div class="dropdown-wrapper ml-2">
      @if (taxYearLoaded) {
<ap-dropdown class="dropdown-tax-year dst-filter-dropdown" [list]="taxYearItems" [selectType]="'single'"
        [title]="'Tax Year'" [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Year'"
        [(ngModel)]="selectedTaxYearItem" (onSelect)="onTaxYearDropdownChange($event)">
  @for (item of taxYearItems; track $index) {
    <ap-dropdown-list-item #dropdownListItem [item]="item"
      [ariaLabel]="setTaxYearAriaLabel(item)" (onSelectItem)="onTaxYearSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
}
    </div>
    <b class="mt-2 ml-2 filter-label">Business Name:</b>
    <div class="dropdown-wrapper ml-2">
      <ap-dropdown class="dropdown-business dst-filter-dropdown" [list]="businessItems" [selectType]="'single'"
        [title]="'Business Name'" [hideTitleOnInput]="true" [inputAriaLabel]="'Business Name'"
        [disabled]="!selectedTaxYear || businessItems.length === 0"
        [(ngModel)]="selectedBusinessItem" (onSelect)="onBusinessDropdownChange($event)">
        @for (item of businessItems; track $index) {
          <ap-dropdown-list-item #dropdownListItem [item]="item"
            [ariaLabel]="setDropdownAriaLabel(item, 'Business Name')"
            (onSelectItem)="onBusinessSelectItem($event)"></ap-dropdown-list-item>
        }
      </ap-dropdown>
    </div>
    @if (gridLoading) {
      <div class="mt-2 ml-2">
        <i class="fa fa-spinner fa-spin"></i>
      </div>
    }
  </div>

  @if (selectedTaxYear && selectedBusiness) {
  <div class="table-actions-section">
    <div class="table-actions-row">
      <div class="table-actions table-actions-left">
        <button type="button" class="btn btn-danger" (click)="checkUncheckAll(true)">Select All</button>
        <button type="button" class="btn btn-danger ml-2" (click)="checkUncheckAll(false)">Clear All</button>
        <button type="button" class="btn btn-danger ml-2" [disabled]="statementFiledStatusUpdating || gridLoading" (click)="markAsFiled()">
          @if (updatingAction === 'markAsFiled') {
            <span><i class="fa fa-spinner fa-pulse"></i></span>
          }Mark As Filed
        </button>
        <button type="button" class="btn btn-danger ml-2" [disabled]="statementFiledStatusUpdating || gridLoading" (click)="markAsNotFiled()">
          @if (updatingAction === 'markAsNotFiled') {
            <span><i class="fa fa-spinner fa-pulse"></i></span>
          }Mark As Not Filed
        </button>
        <button type="button" class="btn btn-danger ml-2" [disabled]="statementFiledStatusUpdating || gridLoading" (click)="markQarAsY()">
          @if (updatingAction === 'markQarAsY') {
            <span><i class="fa fa-spinner fa-pulse"></i></span>
          }Mark QAR As Y
        </button>
        <button type="button" class="btn btn-danger ml-2" [disabled]="statementFiledStatusUpdating || gridLoading" (click)="markQarAsN()">
          @if (updatingAction === 'markQarAsN') {
            <span><i class="fa fa-spinner fa-pulse"></i></span>
          }Mark QAR As N
        </button>
      </div>
    </div>
    <div class="table-search-row">
      <label class="search-label">Search:</label>
      <input type="text" class="search-input" placeholder="Search table..." [(ngModel)]="searchText" (ngModelChange)="onSearchChange()">
    </div>

    <div #tableWrapper class="stmt-filed-table" [class.table-body-has-scroll]="tableBodyHasScroll">
      <div class="dst-mat-grid-layout">
        @if (gridLoading) {
          <div class="dst-mat-grid-loading">
            <mat-spinner [diameter]="40"></mat-spinner>
          </div>
        }
        <div class="dst-mat-grid">
          <table mat-table [dataSource]="dataSource" [fixedLayout]="true" matSort #sort="matSort" class="dst-mat-table stmt-filed-datatable">

            <ng-container matColumnDef="SELECTED">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-select"
                [ngStyle]="getColStyle(getColByField('SELECTED'))">
                {{ getColByField('SELECTED').header }}
              </th>
              <td mat-cell *matCellDef="let row" class="col-select" [ngStyle]="getColStyle(getColByField('SELECTED'))">
                <input
                  type="checkbox"
                  [checked]="row.SELECTED"
                  (change)="onRowSelectChange(row, $event)">
              </td>
            </ng-container>

            <ng-container matColumnDef="STATEMENTID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-center"
                [ngStyle]="getColStyle(getColByField('STATEMENTID'))">
                {{ getColByField('STATEMENTID').header }}
              </th>
              <td mat-cell *matCellDef="let row" class="col-center" [ngStyle]="getColStyle(getColByField('STATEMENTID'))">
                {{ row.STATEMENTID }}
              </td>
            </ng-container>

            <ng-container matColumnDef="PRIMARYLEID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-center"
                [ngStyle]="getColStyle(getColByField('PRIMARYLEID'))">
                {{ getColByField('PRIMARYLEID').header }}
              </th>
              <td mat-cell *matCellDef="let row" class="col-center" [ngStyle]="getColStyle(getColByField('PRIMARYLEID'))">
                {{ row.PRIMARYLEID }}
              </td>
            </ng-container>

            <ng-container matColumnDef="SECONDARYLEID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-center"
                [ngStyle]="getColStyle(getColByField('SECONDARYLEID'))">
                {{ getColByField('SECONDARYLEID').header }}
              </th>
              <td mat-cell *matCellDef="let row" class="col-center" [ngStyle]="getColStyle(getColByField('SECONDARYLEID'))">
                {{ row.SECONDARYLEID }}
              </td>
            </ng-container>

            <ng-container matColumnDef="BRANCHLEID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-center"
                [ngStyle]="getColStyle(getColByField('BRANCHLEID'))">
                {{ getColByField('BRANCHLEID').header }}
              </th>
              <td mat-cell *matCellDef="let row" class="col-center" [ngStyle]="getColStyle(getColByField('BRANCHLEID'))">
                {{ row.BRANCHLEID }}
              </td>
            </ng-container>

            <ng-container matColumnDef="STATEMENTNAME">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-left"
                [ngStyle]="getColStyle(getColByField('STATEMENTNAME'))">
                {{ getColByField('STATEMENTNAME').header }}
              </th>
              <td mat-cell *matCellDef="let row" class="col-left" [ngStyle]="getColStyle(getColByField('STATEMENTNAME'))">
                {{ row.STATEMENTNAME }}
              </td>
            </ng-container>

            <ng-container matColumnDef="ISQAR">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-center"
                [ngStyle]="getColStyle(getColByField('ISQAR'))">
                {{ getColByField('ISQAR').header }}
              </th>
              <td mat-cell *matCellDef="let row" class="col-center" [ngStyle]="getColStyle(getColByField('ISQAR'))">
                {{ isQarDisplay(row) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="FILEDSTATUS">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-center"
                [ngStyle]="getColStyle(getColByField('FILEDSTATUS'))">
                {{ getColByField('FILEDSTATUS').header }}
              </th>
              <td mat-cell *matCellDef="let row" class="col-center" [ngStyle]="getColStyle(getColByField('FILEDSTATUS'))">
                {{ row.FILEDSTATUS }}
              </td>
            </ng-container>

            <ng-container matColumnDef="CREATEDBY">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-center"
                [ngStyle]="getColStyle(getColByField('CREATEDBY'))">
                {{ getColByField('CREATEDBY').header }}
              </th>
              <td mat-cell *matCellDef="let row" class="col-center" [ngStyle]="getColStyle(getColByField('CREATEDBY'))">
                {{ row.CREATEDBY }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="stmt-filed-header-row"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell dst-mat-no-records empty-message-cell" [attr.colspan]="displayedColumns.length">
                No records.
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    @if (!data?.length && !gridLoading) {
      <div class="no-data-msg">
        No statements found.
      </div>
    }
  </div>
  }
</div>
